import { getBrowserApi } from '@fullstory/browser-api';
import { BasePlan, PlanStage } from '@fullstory/proto/fs/services/orgs';
import { useXhr } from '@fullstory/react-hooks';
import { fullstorySelectors, useFetchSettings } from '@fullstory/redux';
import { getBasePlanString, getStageString } from '@fullstory/util/orginfo';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { ZendeskCustomField } from '@fullstory/client-api/goimports/fs_services_webber_internal_zendesk';

const { getOrgId, getUserInfo } = fullstorySelectors;

export const useCSLink = () => {
  const orgId = useSelector(getOrgId);
  const email = useSelector(getUserInfo).email;
  const settings = useFetchSettings();

  const url = getBrowserApi(window)?.getCurrentSessionURL?.() ?? '';
  const stage = getStageString(settings.data?.plan?.planStage ?? PlanStage.UNSET_STAGE);
  const [locationData, setLocationData] = useState<ZendeskCustomField[] | null>(null);

  let plan = getBasePlanString(settings.data?.plan?.basePlan ?? BasePlan.UNSET_PLAN);
  // zendesk expects the plan to be named "pro" instead of "pro (legacy)"
  if (settings.data?.plan?.basePlan === BasePlan.PRO_PLAN) {
    plan = 'Pro';
  }

  const xhr = useXhr();
  useEffect(() => {
    if (!locationData) {
      xhr
        .GetJson('/getLocation')
        .Success((_, rsp: any) => {
          setLocationData(rsp);
        })
        .Fail((_, rsp) => {
          console.warn(`Failed to get location: ${rsp}`);
        })
        .Send({});
    }
  }, [locationData, xhr]);

  const searchParams = useMemo(() => {
    const params = new URLSearchParams({
      tf_52025108: orgId,
      tf_360047839294: `baseplan_${plan.toLowerCase()}`,
      tf_360047839474: `stage_${stage.toLowerCase()}`,
      tf_anonymous_requester_email: email,
      tf_15332860060311: url,
    });
    locationData?.forEach(loc => {
      params.append(`tf_${loc.id}`, loc.value);
    });

    return params;
  }, [email, locationData, orgId, plan, stage, url]);

  return `https://help.fullstory.com/hc/en-us/requests/new?${searchParams.toString()}`;
};
